import React, {Component} from 'react';
import Tools from "./components/Tools/Tools";
import {fabric} from "fabric";
import FabricToImageData from 'fabric-to-image-data'
import { saveAs } from 'file-saver';

import './Boom.css'
import Zoom from "./components/Zoom/Zoom";
import Background from "./components/Background/Background";
import Crop from "./components/Zoom/Crop";
import * as smartcrop from "smartcrop";
import html2canvas from "html2canvas";
import * as htmlToImage from "html-to-image";



FabricToImageData(fabric);

let obj;
let canvas;

class Boom extends Component {

    state = {
        wSize: 400,
        hSize: 400,
        fontSize: 14,
        txtColor:`rgba(74,74,74,1)`,
        align: 'center',
        fontFamily: 'SGKara',
        bgImage: '',
        bgUnCrop:'',
        reSize: true,
        x: 0,
        y: 0,
        logo: ''
    }


    componentDidMount() {
        canvas = this.canvas = new fabric.Canvas(this.canvref.id);
        this.addText();

    }

    componentDidUpdate() {
        canvas.setHeight(this.state.hSize);
        this.setBackGround(this.state.bgImage);
        //this.setBackgroundFromDataUrl(this.state.bgImage);

        if (obj = canvas.getActiveObject()) {
            //setObj(_canv.current.getActiveObject());
            this.setStyle(obj, 'fontSize', this.state.fontSize);
            this.setStyle(obj, 'fontFamily', this.state.fontFamily);
            this.setStyle(obj, 'fill', this.state.txtColor);
            this.setStyle(obj, 'textAlign', this.state.align);
           // console.log(obj);
        }
        canvas.renderAll();
    }


    changeCanvasSize = (type) => {
        switch (type) {
            case 'post':
                return this.setState({wSize: 400, hSize: 400});
            case 'story':
                return this.setState({wSize: 400, hSize: 700});
            default:
                throw new Error('Unknown filter:' + type)
        }

    }

    changeFontSize = (e) => {
        this.setState({fontSize: e.target.value});

    }

    colorText = (e) => {
        this.setState({txtColor:e});

     }

    alignText = (e) => {
        this.setState({align: e.target.value});

    }

    setFontFamily = (e) => {
        this.setState({fontFamily: e.target.value});
    }

    setbgImage = (e) => {
        this.setState({bgImage: e,bgUnCrop:e});

    }
    setLogo = (e) => {
        this.setState({logo: e});
        this.insertLogo(this.state.logo);
    }

    addText = () => {
        var text = new fabric.Textbox('محل نوشتن شمااست.' + "\u200F",
            {
                fontSize: this.state.fontSize,
                fontFamily: this.state.fontFamily,
                textAlign: this.state.align,
                fill:this.state.txtColor,
                width: 140,
                left: 100,
                top: 100,
                id: 'Text'
            });

        canvas.add(text);

    }


    setStyle = (object, styleName, value) => {
        if (object.setSelectionStyles && object.isEditing) {
            var style = {};
            style[styleName] = value;
            object.setSelectionStyles(style).setCoords();
            if (styleName === 'fontSize') {
                this.setStyle(object, 'width', value * 10);
            }
        }
        else {
            //object[styleName] = value;
            object.set(styleName, value);
            if (styleName === 'fontSize') {
                this.setStyle(object, 'width', value * 10);
            }
        }
        canvas.renderAll();
    }


    setBackGround = (bg) => {
        // var img1 = new Image();
        // img1.src = bg;
        // smartcrop.crop(img1, { width: 400, height: 400 }).then(function(result) {
        //    console.log(result);
        // });


        fabric.Image.fromURL(bg, function (img) {
            //  this.setState({bgImage:bg});

            canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
                "left": 0,
               "top": 0,

                // "left":(canvas.width/2)-(img.width/2),
                // "top":(canvas.height/2)-(img.height/2),

                // scaleX :1,   //new update
                // scaleY:1,
                scaleX: canvas.width / img.width,
                scaleY: canvas.height / img.height
            });


        });
    }

   setBackgroundFromDataUrl = (dataUrl) => {
        if (!dataUrl) { return true; }

        let img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.onload = () => {

            // maxWidth // Max width of the canvas
            // maxHeight //Max height of canvas
            let maxWidth=400;
            let maxHeight=400;

            let imgWidth = img.width; // Current image width
            let imgHeight = img.height; // Current image height

            let widthAspectRatio = maxWidth / imgWidth;
            let heightAspectRatio = maxHeight / imgHeight;

            let finalAspectRatio = Math.min(widthAspectRatio, heightAspectRatio)

            let finalHeight = imgHeight * finalAspectRatio;
            let finalWidth = imgWidth * finalAspectRatio;

            let imgTop = 0;
            if (maxHeight > finalHeight) {
                imgTop = (Math.round(maxHeight) - Math.round(finalHeight)) / 2;
            }

            let imgLeft = 0;
            if (maxWidth > finalWidth) {
                imgLeft = (Math.round(maxWidth) - Math.round(finalWidth)) / 2;
            }

            let nsgImage = new fabric.Image(img).scale(finalAspectRatio);
            nsgImage.set({ left: imgLeft, top: imgTop });
            canvas.setBackgroundImage(nsgImage, () => canvas.renderAll());

        }

        img.src = dataUrl;

    };








    insertLogo = (img) => {
        fabric.Image.fromURL(img, function (oImg) {
            var l = Math.random() * 400;
            var t = Math.random() * 400;
            oImg.scale(0.2);
            oImg.set({'id': 'logo'});
            oImg.set({'left': l});
            oImg.set({'top': t});
            canvas.add(oImg);
        });
    }


    deleteLogo = () => {
        canvas.getObjects().forEach(function (o) {
            if (o.id === 'logo') {
                canvas.setActiveObject(o);
                canvas.remove(o);
            }
        })


    }


    onKeyPressed = (e) => {
        switch (e.keyCode) {
            case 46: // delete
                var activeObject = canvas.getActiveObject();
                if (!activeObject) canvas.remove(activeObject);
        }
        e.preventDefault();
    };


    // onDelete = () => {
    //
    //     canvas.remove(obj);
    //     canvas.renderAll();
    // }

    resizeHandler = () => {
        this.setState({reSize: !this.state.reSize});

    }

    resizeDone = (base64) => {
        this.setState({reSize: !this.state.reSize,bgImage:base64});
        //console.log('base64:'+base64);
    }

    export()
    {

        htmlToImage.toBlob(document.getElementById('fabric')
            , { useCORS:true,
                allowTaint: true,

        }
        )
            .then(function (canvas) {
                window.saveAs(canvas, 'Button.png');
                //this.open(canvas.toDataURL('png'));
            });




        // const reader = new FileReader();
        // canvas.toBlob(blob => {
        //     reader.readAsDataURL(blob);
        //     reader.onloadend = () => {
        //         this.saveAs(reader.result, 'cropped.jpg')
        //     }
        // })
        // html2canvas(document.getElementById("fabric"))
        //     .then(function (canvas){
        //         var tempcanvas = document.createElement('canvas');
        //         tempcanvas.width=465;
        //         tempcanvas.height=524;
        //         var context=tempcanvas.getContext('2d');
        //         context.drawImage(canvas,465,40,465,524,0,0,465,524);
        //         console.log(context);
                // var link=document.createElement("a");
                // link.href=canvas.toDataURL('image/jpg');
                // link.download = 'screenshot.jpg';
                // link.click();
            // });




            // var e = new Date,
            //     t = e.getMonth() + 1 + "" + e.getDate() + e.getFullYear() + e.getHours() + e.getMinutes() + e.getSeconds(),
            //     a = canvas.toDataURL().replace(/^data:image\/[^;]*/, "data:application/octet-stream"),
            //     A = document.createElement("a");
            // if (t += ".png", A.setAttribute("href", a), A.setAttribute("crossOrigin", "anonymous"), A.setAttribute("target", "_blank"), A.setAttribute("download", t), document.createEvent) {
            //     console.log(t);
            //     // var n = document.createEvent("MouseEvents");
            //     // n.initEvent("click", !0, !0), A.dispatchEvent(n)
            // } else A.click && A.click()



        //
        // htmlToImage.toBlob(canvas[0], { useCORS:true})
        //     .then(function (blob) {
        //         window.saveAs(blob, 'Button.png');
        //     });
        // canvas.renderAll();
        // const el = document.body;
        //
        // html2canvas(el, {
        //     useCORS:true,
        //     allowTaint: true,
        //
        // }).then(function (canvas) {
        //     var imgBase64 = canvas.toDataURL();
        //     console.log(imgBase64);
        // //     // var imgURL = "data:image/" + imgBase64;
        // //     // var triggerDownload = ("<a>").attr("href", imgURL).attr("download", "layout_"+new Date().getTime()+".jpeg").appendTo("body");
        // //     // triggerDownload[0].click();
        // //     // triggerDownload.remove();
        // });
    }




    render() {
        return (
            <div className="container p-5">

                <div className="main" style={this.state.reSize ? {display: 'flex'} : {display: 'none'}}>


                     <Background image={this.setbgImage}/>

                    <div className="preview">

                        <label className="bg-secondary text-light w-100">Preview</label>
                        <button className="btn btn-sm btn-secondary float-right" onClick={() => this.resizeHandler()}>ReSize</button>

                        <div className="canvas">
                            <div id="view">
                            <canvas id="fabric"
                                    className="fabric"
                                    width="400"
                                    onKeyDown={this.onKeyPressed}
                                    tabIndex="0"
                                    dir="rtl"
                                    height={this.state.hSize}
                                    ref={canvref => this.canvref = canvref}

                            />
                            </div>

                        </div>
                    </div>

                    < Tools
                        postSize={this.changeCanvasSize}
                        storySize={this.changeCanvasSize}
                        fontSize={this.changeFontSize}
                        colorText={this.colorText}
                        fontFamily={this.setFontFamily}
                        backgroundUpload={this.setbgImage}
                        logoUpload={this.setLogo}
                        delete={this.deleteLogo}
                        align={this.alignText}
                        export={this.export}
                    />
                </div>

                {/*<Zoom*/}
                    {/*size={this.state.hSize}*/}
                    {/*image={this.state.bgImage}*/}
                    {/*show={this.state.reSize}*/}
                    {/*done={this.resizeHandler}/>*/}
                <Crop
                    size={this.state.hSize}
                    image={this.state.bgUnCrop}
                    show={this.state.reSize}
                    done={this.resizeDone}/>

            </div>
        );
    }
}

export default Boom;